import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "appointment-data-card-wrapper",
      class: {
        "appointment-data-card-wrapper_error": _vm.isErrorState,
        "appointment-data-card-wrapper_primary":
          !_vm.isErrorState && _vm.hasPrimaryBorder,
      },
    },
    [
      _vm.isSkeletonNeeded
        ? _c("AppointmentDataCardSkeleton", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLoading,
                expression: "isLoading",
              },
            ],
            attrs: {
              "data-qa": `${_vm.qaLocator}_skeleton`,
              width: _vm.imageWidth,
              height: _vm.withoutAvatar ? _vm.minHeight : _vm.imageHeight,
              "without-avatar": _vm.withoutAvatar,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoading || !_vm.isSkeletonNeeded,
              expression: "!isLoading || !isSkeletonNeeded",
            },
          ],
          staticClass: "appointment-data-card",
          class: _vm.cardClass,
          style: { minHeight: `${_vm.minHeight}px` },
          attrs: { "data-qa": _vm.qaLocator },
        },
        [
          _vm.imageSrc
            ? _c(VImg, {
                staticClass: "appointment-data-card__image",
                class: {
                  "appointment-data-card__image_border": _vm.hasImageBorder,
                },
                attrs: {
                  "data-qa": `${_vm.qaLocator}_image`,
                  alt: _vm.name,
                  src: _vm.imageSrc,
                  width: _vm.imageWidth,
                  height: _vm.imageHeight,
                  contain: "",
                },
              })
            : _vm.iconStub
            ? _c(
                "div",
                {
                  staticClass: "appointment-data-card__icon-stub-wrapper",
                  attrs: { "data-qa": `${_vm.qaLocator}_image_stub` },
                },
                [
                  _c("div", {
                    staticClass: "ui-icon_type_40",
                    class: _vm.iconStub,
                    style: {
                      width: `${_vm.imageWidth}px`,
                      height: `${_vm.imageHeight}px`,
                      lineHeight: `${_vm.imageHeight}px`,
                      fontSize: `${
                        _vm.iconStubSizeRatio *
                        Math.min(_vm.imageHeight, _vm.imageWidth)
                      }px`,
                    },
                  }),
                ]
              )
            : _vm.prependIcon
            ? _c(
                VIcon,
                {
                  class: _vm.isErrorState
                    ? "error--text"
                    : "icon-secondary--text",
                },
                [_vm._v("\n      " + _vm._s(_vm.prependIcon) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              class: [
                { "ml-4": _vm.imageSrc || _vm.iconStub || _vm.prependIcon },
                _vm.$slots.icon ? "mr-4" : "mr-13",
              ],
            },
            [
              _vm.name
                ? [
                    _c(
                      "div",
                      {
                        class: [
                          _vm.isBoldName ? "text-subtitle-1" : "text-body-1",
                          _vm.isErrorState ? "error--text" : "text--text",
                        ],
                        attrs: { "data-qa": `${_vm.qaLocator}_name` },
                      },
                      [_vm._v("\n          " + _vm._s(_vm.name) + "\n        ")]
                    ),
                    _vm._v(" "),
                    _vm.subtitle
                      ? _c(
                          "div",
                          {
                            staticClass: "text-body-2",
                            class: [
                              _vm.isErrorState
                                ? "error--text"
                                : "text-secondary--text",
                            ],
                            attrs: { "data-qa": `${_vm.qaLocator}_subtitle` },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.subtitle) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.validationText
                      ? _c(
                          "div",
                          {
                            staticClass: "text-body-2 text-secondary--text",
                            attrs: { "data-qa": `${_vm.qaLocator}_validation` },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.validationText) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(
                      _vm.filteredDescriptions,
                      function ({ text, qaLocatorName, classes }, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class:
                              classes || "text-body-2 text-secondary--text",
                            attrs: {
                              "data-qa": `${_vm.qaLocator}_${
                                qaLocatorName || "description"
                              }`,
                            },
                          },
                          [_vm._v("\n          " + _vm._s(text) + "\n        ")]
                        )
                      }
                    ),
                  ]
                : _vm.titleStub
                ? _c(
                    "div",
                    { staticClass: "text-body-1 text-secondary--text" },
                    [_vm._v("\n        " + _vm._s(_vm.titleStub) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.warnDescription
                ? _c(
                    "div",
                    {
                      staticClass: "text-body-2 text-warning--text",
                      attrs: { "data-qa": `${_vm.qaLocator}_warn_description` },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.warnDescription) + "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.errorDescription
                ? _c(
                    "div",
                    {
                      staticClass: "text-body-2 text-error--text",
                      attrs: {
                        "data-qa": `${_vm.qaLocator}_error_description`,
                      },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.errorDescription) + "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.$slots.icon
            ? _c(
                "div",
                {
                  staticClass: "appointment-data-card__icon",
                  class: _vm.isErrorState
                    ? "error--text"
                    : "icon-secondary--text",
                  attrs: { "data-qa": `${_vm.qaLocator}_icon` },
                },
                [_vm._t("icon")],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }